'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class SubMenuLink extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      style: this.props.style,
      originalStyle: this.props.style,
      hover: false
    };
  }
  handleEnter() {
    const style = Object.assign({}, this.state.style, this.props.hoverStyles);
    this.setState({
      style: style,
      hover: true
    });
  }

  // This resets the styles
  handleLeave() {
    this.setState({
      style: this.state.originalStyle,
      hover: false
    });
  }
  render() {
    const rel = this.props.rel || null;
    return /*#__PURE__*/_react.default.createElement("a", {
      onMouseEnter: this.handleEnter.bind(this),
      onMouseLeave: this.handleLeave.bind(this),
      className: this.props.className,
      target: this.props.target,
      href: encodeURI(this.props.href),
      alt: this.props.alt,
      rel: rel,
      style: this.state.style
    }, this.props.children);
  }
}
exports.default = SubMenuLink;
;
SubMenuLink.defaultProps = {
  alt: ''
};
SubMenuLink.propTypes = {
  style: _propTypes.default.object,
  hoverStyle: _propTypes.default.object,
  className: _propTypes.default.string,
  href: _propTypes.default.string,
  alt: _propTypes.default.string,
  target: _propTypes.default.string,
  hoverStyles: _propTypes.default.object,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  rel: _propTypes.default.string
};